"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_layout_1 = require("@carvana/helios-layout");
var test_attributes_1 = require("@carvana/test-attributes");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var uuid_1 = require("uuid");
var Tab_1 = __importDefault(require("./Tab"));
var TabBar_1 = __importDefault(require("./TabBar"));
var TabContext_1 = __importDefault(require("./TabContext"));
var TabPanel_1 = __importDefault(require("./TabPanel"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Tabs = function (_a) {
    var children = _a.children, className = _a.className, initialTab = _a.initialTab, controlledActiveTab = _a.activeTab, onTabChange = _a.onTabChange;
    var isClient = (0, helios_layout_1.useWindowLoaded)();
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var _b = (0, react_1.useState)(initialTab), activeTab = _b[0], setActiveTab = _b[1];
    var isControlled = controlledActiveTab !== undefined;
    var finalActiveTab = isControlled ? controlledActiveTab : activeTab;
    var handleTabChange = function (tab) {
        if (!isControlled) {
            setActiveTab(tab);
        }
        if (onTabChange) {
            onTabChange(tab);
        }
    };
    var idPrefix = (0, react_1.useRef)((0, uuid_1.v4)());
    var contextValue = (0, react_1.useMemo)(function () { return ({
        activeTab: finalActiveTab,
        setActiveTab: handleTabChange,
        idPrefix: idPrefix.current
    }); }, [finalActiveTab, handleTabChange]);
    return isClient ? ((0, jsx_runtime_1.jsx)(TabContext_1.default.Provider, __assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)(Container, __assign({}, getTestAttributes('tabs'), { className: className }, { children: children })) }))) : null;
};
exports.Tabs = Tabs;
exports.Tabs.TabBar = TabBar_1.default;
exports.Tabs.Tab = Tab_1.default;
exports.Tabs.TabPanel = TabPanel_1.default;
var templateObject_1;
